import React, {useEffect, useState} from "react";
// The lazy build keeps the (large) player out of the main bundle - it is fetched as a separate chunk when a
// page with a video is shown (loading="page" below, rather than waiting for the video to scroll into view).
import MuxPlayer from "@mux/mux-player-react/lazy";
import {getMyCourseVideo} from "../api/CourseApi";
import {getErrorMessageForField} from "../utils/formUtils";

/**
 * Plays one course video.  This is what a {video:key} in a course page turns into (see CourseView).
 * The MUX tokens are short-lived, so they are fetched each time the player mounts instead of being cached.
 */
export function CourseVideoPlayer({courseVideoId, title}) {
  const [video, setVideo] = useState(null);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    setVideo(null);
    getMyCourseVideo(courseVideoId, (status, data, newErrors) => {
      if (status === 200) {
        setVideo(data);
        setErrors([]);
      } else {
        setErrors(newErrors);
      }
    });
  }, [courseVideoId]);

  if (getErrorMessageForField(errors, '')) {
    return (
      <div className="course-video-message">
        {title && <div className="fw-bold">{title}</div>}
        <div className="usacm-error-message">{getErrorMessageForField(errors, '')}</div>
      </div>
    );
  }
  if (!video) {
    return <div className="course-video-message text-muted">Loading video...</div>;
  }
  return (
    <MuxPlayer
      loading="page"
      playbackId={video.playback_id}
      tokens={video.tokens}
      metadata={{video_id: String(video.id), video_title: video.title}}
      title={video.title}
      style={video.aspect_ratio ? {aspectRatio: video.aspect_ratio.replace(':', ' / ')} : undefined}
    />
  );
}
